import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "ngx-form-field",
  templateUrl: "./form-field.component.html",
  styleUrls: ["./form-field.component.scss"],
})
export class FormFieldComponent implements OnInit {
  @Input() field: any = {};
  @Output() update = new EventEmitter();

  constructor() {}

  ngOnInit() {
    if (!this.field.step) {
      this.field.step = 1;
    }
  }

  updateData() {
    this.update.emit(this.field);
    console.log(this.field);
  }

  addOption() {
    if (this.field.options) {
      this.field.options.push("");
    } else {
      this.field.options = [""];
    }
  }

  removeOption(i) {
    this.field.options.splice(i, 1);
  }

  addValidation() {
    let blankVal = { type: "", params: [] };
    if (this.field.validations) {
      this.field.validations.push(blankVal);
    } else {
      this.field.validations = [blankVal];
    }
  }

  updateOption(event, index) {
    this.field.options[index] = event.target.value;
    this.updateData();
  }

  updateValidation(event, index, type) {
    let validation = this.field.validations[index];
    switch (type) {
      case "value":
        if (validation.type !== "email" && validation.type !== "required") {
          validation.params[0] = event.target.value;
        }

        break;

      case "error":
        if (validation.type !== "email" && validation.type !== "required") {
          validation.params[1] = event.target.value;
        } else {
          validation.params[0] = event.target.value;
          delete validation.params[1];
        }

        break;
    }
    this.field.validations[index] = validation;
    console.log(this.field);
    this.updateData();
  }

  getValidationValue(index, type) {
    let validation = this.field.validations[index];

    switch (type) {
      case "value":
        if (validation.type !== "email" && validation.type !== "required") {
          return validation.params[0] || "";
        }

        break;

      case "error":
        if (validation.type !== "email" && validation.type !== "required") {
          return validation.params[1] || "";
        } else {
          return validation.params[0] || "";
        }

        break;
    }
  }

  removeValidation(i) {
    this.field.validations.splice(i, 1);
  }
}
